import { Action, DockType, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import PreviewTemplates from "../components/MainGrid/PreviewTemplates/PreviewTemplates";

export const folderViewUpdate: Action = [{
  data: {
    url: '/folderViewUpdate',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  type: OperationType.request
}, {
  name: 'removePersistentActionData',
  type: OperationType.action
}];

export const onDrawerResize: Action = [{
  name: 'updateFilesGridHeight',
  type: OperationType.action
}];

export const clearFilterMainGridAndGetNewData: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  // TODO update dispather to remove persistant data in flow to remove this operation
  data: {
    template: {
      bind: {
        mainGridFilter: '{}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'clearFilterMainGrid',
  type: OperationType.action
}, {
  name: 'getMainGridData',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const clearFilterMainGrid: Action = [{
  persistent: ['mainGridFilter'],
  type: OperationType.removePersistentData
}];

export const clearSearchBarFilter: Action = [{
  moduleName: 'SearchBar',
  name: 'clearSearchBar',
  args: ['withRefresh']
}];

export const filterMainGrid: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  persistent: ['mainGridFilter'],
  type: OperationType.addPersistentData
}, {
  name: 'refreshMainGrid',
  type: OperationType.action
}, {
  condition: '!{favoritesOnly} && {clearSearchBar}',
  conditionOperations: [{
    data: {
      template: {
        withRefresh: false
      }
    },
    moduleName: 'SearchBar',
    name: 'clearSearchBar',
    args: ['withRefresh']
  }],
  elseOperations: [{
    condition: '{clearQuickFilters}',
    conditionOperations: [{
      data: {
        template: {
          withRefresh: false
        }
      },
      moduleName: 'MainGrid',
      name: 'clearFilter',
      args: ['withRefresh']
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const refreshMainGrid: Action = [{
  moduleName: 'NavigationGrid',
  name: 'resetGridData'
}, {
  name: 'getMainGridData',
  type: OperationType.action
}, {
  condition: `_.includes(["view/taskList"],{route()}) && !{skipAdvancedSearchLoad}`,
  type: OperationType.conditional,
  conditionOperations: [{
    name: 'loadAdvancedSearchList',
    type: OperationType.action
  }]
}];

export const refreshMainGridWhenDrawerIsNotOpen: Action = [{
  condition: '{route() === "view/submissionList"}',
  conditionOperations: [{
    moduleName: 'SubmissionsList',
    name: 'isDrawerOpen',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  condition: '{route() === "view/taskList"}',
  conditionOperations: [{
    moduleName: 'TaskList',
    name: 'isDrawerOpen',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  condition: '!{isDrawerOpen}',
  conditionOperations: [{
    moduleName: 'App',
    name: 'checkForAdditionalDispatchers',
    mappingName: 'pingInProcess',
    type: OperationType.addOperationData
  }, {
    condition: '!{pingInProcess}',
    conditionOperations: [{
      name: 'refreshMainGridOnCurrentPosition',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const refreshMainGridOnCurrentPosition: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'refreshMainGridToCurrentPositionWithoutMask',
  type: OperationType.action
}, {
  condition: '{route() === "view/submissionList"}',
  conditionOperations: [{
    args: ['gridData'],
    moduleName: 'SubmissionsList',
    name: 'updateSelectedRecordAfterGridUpdate'
  }],
  type: OperationType.conditional
}, {
  condition: '{route() === "view/taskList"}',
  conditionOperations: [{
    args: ['gridData'],
    moduleName: 'TaskList',
    name: 'updateSelectedRecordAfterGridUpdate'
  }],
  type: OperationType.conditional
}, {
  condition: '!{refreshFromFilesTab}',
  conditionOperations: [{
    moduleName: 'App',
    type: OperationType.unmaskModule
  }],
  type: OperationType.conditional
}];

export const getMainGridData: Action = [{
  name: 'mainGridRequest',
  type: OperationType.action
}, {
  moduleName: 'NavigationGrid',
  name: 'setGridData',
  args: ['gridData']
}, {
  moduleName: 'MainGrid',
  name: 'updateScrollbarState',
}];

export const getMainGridInitialData: Action = [{
  name: 'mainGridRequest',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        gridConfig: '_.get({gridData}, "gridConfig")',
        filterData: '{initializeUserData.searchBar}',
        dueSoon: '{initializeUserData.preferences.dueSoon}',
        readerColumnsData: '_.get({gridData}, "readerColumns")',
        sortInfo: '_.get({gridData}, "gridContentInfo.pagedListInfo")',
        selectionLimit: '{initializeUserData.sapphireLimitSelection}'
      }
    }
  },
  moduleName: 'MainGrid',
  name: 'setConfigData',
  args: ['gridConfig', 'filterData', 'dueSoon', 'readerColumnsData', 'sortInfo', 'cookieParams', 'selectionLimit'],
  type: OperationType.addOperationData
}, {
  data: {
    update: {
      gridData: {
        bind: {
          items: '_.get({gridData}, "items") || []'
        }
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'NavigationGrid',
  name: 'setGridData',
  args: ['gridData']
}, {
  moduleName: 'MainGrid',
  name: 'setDynamicSize'
}, {
  moduleName: 'MainGrid',
  name: 'updateScrollbarState',
}, {
  name: 'openDrawerViaCookieParams',
  type: OperationType.action
}, {
  persistent: ['cookieParams'],
  type: OperationType.removePersistentData
}];

/**
 * If submission is filtered by email link or copy link(feature) this part is used for opening drawer for that submission.
 */
export const openDrawerViaCookieParams: Action = [{
  condition: '_.get({gridData}, "items").length === 1 && _.get({cookieParams}, "submissionId")',
  conditionOperations: [{
    data: {
      filesInView: false,
      forceOpenDrawer: true,
      quotesInView: false,
      template: {
        bind: {
          selectedSubmissions: '[{gridData.items[0]}]'
        }
      }
    },
    evaluate: true,
    executeType: 'visible',
    moduleName: '{currentModuleName}',
    name: 'gridOnSelectionChange',
    args: [
      'selectedSubmissions',
      'forceOpenDrawer',
      'quotesInView',
      'filesInView'
    ]
  }, {
    moduleName: 'NavigationGrid',
    name: 'selectFirst'
  }, {
    name: 'updateDrawerState',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const mainGridRequest: Action = [{
  data: {
    template: {
      bind: {
        userName: `_.get({initializeUserData}, "userProfile.userInfo.userName")`,
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'MainGrid',
  name: 'updateDataWithFilterParams',
  args: ['pageSize', 'pageNumber', 'mainGridFilter', 'userName'],
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  condition: '{scrollRequestParams}',
  conditionOperations: [{
    data: {
      update: {
        params: {
          bind: {
            size: '{scrollRequestParams.pageSize}',
            index: '{scrollRequestParams.pageNumber}'
          }
        }
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  moduleName: 'MainGrid',
  name: 'getDataUrl',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        url: '{getDataUrl}',
        params: '{params}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'gridDataResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{gridDataResponse}',
        gridData: '{gridDataResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: '_.get({gridData}, "tasks")',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          actionData: '{gridData.tasks}'
        }
      }
    },
    persistent: ['actionData'],
    type: OperationType.addPersistentData
  }, {
    moduleName: 'ContextMenu',
    name: 'setData',
    args: ['actionData']
  }, {
    condition: '_.includes(["view/submissionList", "view/taskList"],{route()})',
    conditionOperations: [{
      name: 'setActionToolbarConfig',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  moduleName: 'MainGrid',
  args: ['gridData'],
  name: 'updateCheckboxSelection'
}, {
  name: 'configureWidgetsGrid',
  type: OperationType.action
}];

export const configureWidgetsGrid: Action = [{
  condition: '_.includes(["view/dashboard"],{route()})',
  conditionOperations: [{
    moduleName: 'Widgets',
    name: 'setActiveTab',
    args: ['gridDataResponse']
  }, {
    name: 'dueSoonOverdueRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const dueSoonOverdueRequest: Action = [{
  condition: '{withMainGridChange}',
  conditionOperations: [{
    moduleName: 'MainGrid',
    name: 'changeChartFolderViewConfiguration',
    args: ['dataIndex', 'hidden']
  }],
  type: OperationType.conditional
}, {
  moduleName: 'DueSoonOverdueGrid',
  name: 'createRequestData',
  mappingName: 'dueSoonOverdueGridRequest',
  args: ['gridDataResponse'],
  type: OperationType.addOperationData
}, {
  data: {
    url: '/submissionsView',
    template: {
      bind: {
        params: '{dueSoonOverdueGridRequest}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'dueSoonOverdueGridResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{dueSoonOverdueGridResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'DueSoonOverdueGrid',
  name: 'setData',
  args: ['dueSoonOverdueGridResponse']
}];

export const markSubmissionAsFavorite: Action = [{
  data: {
    template: {
      bind: {
        submissionTicket: '{selectedSubmission.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    template: {
      method: 'put',
      bind: {
        url: '"/submissions/" + {submissionTicket} + "/markSubmissionAsFavorite"',
      }
    }
  },
  mappingName: 'markAsFavoriteResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{markAsFavoriteResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: '{route()} === "view/dashboard"',
  conditionOperations: [{
    name: 'refreshMainGridOnCurrentPosition',
    type: OperationType.action
  }],
  elseOperations: [{
    moduleName: 'MainGrid',
    name: 'updateMainGridAfterFavoriteChange',
    args: ['selectedSubmission']
  }, {
    moduleName: 'SubmissionsList',
    name: 'updateSelectedRecordAfterFavoriteChange',
    args: ['selectedSubmission']
  }],
  type: OperationType.conditional
}];

export const openPreviewTemplatesDialog: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  children: [{
    render: PreviewTemplates,
    propArgs: ['initializeUserData']
  }],
  className: 'md selectTemplate',
  title: 'previewTemplates.title',
  closable: true,
  items: [{
    btnName: 'previewTemplates.cancel',
    operations: [],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'previewTemplates.select_button',
    btnConfig: {
      themeColor: 'primary',
      disabled: true,
      pos: Position.end
    },
    operations: [{
      moduleName: 'PreviewTemplates',
      name: 'createFromTemplate',
    }],
  }],
  type: OperationType.dialog
}, {
  waitForModule: true,
  name: 'templatesSearch',
  type: OperationType.action
}, {
  moduleName: 'PreviewTemplates',
  args: ['templatesData', 'files'],
  name: 'setData'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const updateTemplatePreviewSaveButton: Action = [{
  buttons: [{
    name: 'previewTemplates.select_button',
    disabled: '!{buttonDisabled}'
  }],
  type: OperationType.updateDialog
}];

export const getTemplateDetails: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'getSubmissionById',
  type: OperationType.action
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+ {submissionDetails.projectId} +"/workflows"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'workflowsResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{workflowsResponse}',
        workflows: '{workflowsResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'PreviewTemplates',
  args: ['submissionDetails', 'workflows'],
  name: 'setTemplateDetails'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const isClaimScopeActive: Action = [{
  data: {
    template: {
      method: 'get',
      url: '/submissions/getGeneralInfo'
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'Details',
  args: ['responseData'],
  name: 'setShowClaim'
}]

export const templatesSearch: Action = [{
  data: {
    defaultParams: {
      ascending: true,
      folder: "SUBMISSION_TEMPLATES",
      isTemplate: true,
      size: 200,
      sortProperty: "submissionId"
    }
  },
  type: OperationType.data
}, {
  condition: `{loadNewData}`, //this condition will be true only on preview template filter change
  conditionOperations: [{
    data: {
      update: {
        defaultParams: {
          bind: {
            submissionNameInputText: '{submissionNameInputText}'
          }
        }
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  data: {
    url: '/submissionsView',
    update: {
      bind: {
        params: '{defaultParams}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'templatesDataResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{templatesDataResponse}',
        templatesData: '{templatesDataResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: `{loadNewData}`, //this condition will be true only on preview template filter change
  conditionOperations: [{
    moduleName: 'PreviewTemplates',
    name: 'loadFilteredTemplates',
    args: ['responseData']
  }, {
    persistent: ['loadNewData'],
    type: OperationType.removePersistentData
  }],
  type: OperationType.conditional
},];

export const clearFormAndGetProjectRelatedData: Action = [{
  name: 'clearSearchBarFilter',
  type: OperationType.action
}, {
  moduleName: 'CustomFieldsFilter',
  name: 'resetFilter'
}, {
  data: {
    method: 'post',
    url: '/filters/projectsInfo',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  mappingName: 'filterDataResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        newFilterData: '{filterDataResponse.searchBar}'
      }
    }
  },
  moduleName: 'FilterForm',
  name: 'updateFilterData',
  args: ['newFilterData']
}];

export const getPreferencesForAutoRefresh: Action = [{
  moduleName: 'MainGrid',
  name: 'createPinger',
  args: ['preferencesData']
}, {
  evaluate: true,
  moduleName: '{currentModuleName}',
  name: 'setPreferencesData',
  args: ['preferencesData']
}];

export const refreshMainGridToCurrentPositionWithoutMask: Action = [{
  moduleName: 'NavigationGrid',
  name: 'getScrollPosition',
  mappingName: 'scrollPosition',
  type: OperationType.addOperationData
}, {
  moduleName: 'MainGrid',
  name: 'getGridConfigJsonData',
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  data: {
    url: '/folderViewUpdate',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  type: OperationType.request
}, {
  name: 'refreshMainGrid',
  type: OperationType.action
}, {
  moduleName: 'NavigationGrid',
  args: ['scrollPosition'],
  name: 'scrollToLastPosition'
}, {
  name: 'preserveFocusAfterRefresh',
  type: OperationType.action
}];

export const preserveFocusAfterRefresh: Action = [{
  moduleName: 'MainGrid',
  name: 'getLastSelectedElement',
  mappingName: 'fakeClickEvent',
  type: OperationType.addOperationData
}, {
  condition: '{fakeClickEvent.dataItem}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          dataItem: '{fakeClickEvent.dataItem}',
          event: '{fakeClickEvent.nativeEvent}'
        }
      }
    },
    moduleName: 'NavigationGrid',
    name: 'updateSelection',
    args: ['dataItem', 'event']
  }],
  type: OperationType.conditional
}];

export const updateSelectionConfirmed: Action = [{
  args: ['dataItem', 'options'],
  moduleName: 'NavigationGrid',
  name: 'updateSelectionConfirmed'
}, {
  persistent: ['dataItem', 'options'],
  type: OperationType.removePersistentData
}];

export const isSelectionChangeAllowed: Action = [{
  condition: '{route() === "view/submissionList"}',
  conditionOperations: [{
    mappingName: 'isDrawerOpen',
    moduleName: 'SubmissionsList',
    name: 'isDrawerOpen',
    type: OperationType.addOperationData
  }, {
    condition: '{isDrawerOpen}',
    conditionOperations: [{
      mappingName: 'changeAllowed',
      moduleName: 'DrawerContent',
      name: 'isAllowedTabChange',
      type: OperationType.addOperationData
    }, {
      condition: '{changeAllowed}',
      conditionOperations: [{
        name: 'updateSelectionConfirmed',
        type: OperationType.action
      }],
      elseOperations: [{
        items: [{
          btnConfig: {
            dock: DockType.bottom,
            fillMode: 'flat',
            pos: Position.end
          },
          btnName: 'common.cancel',
          operations: [{
            moduleName: 'NavigationGrid',
            name: 'focusLastSelectedIndexRow'
          }]
        }, {
          btnConfig: {
            dock: DockType.bottom,
            pos: Position.end,
            themeColor: 'error'
          },
          btnName: 'common.exit',
          operations: [{
            name: 'updateSelectionConfirmed',
            type: OperationType.action
          }]
        }],
        text: 'drawerTabChangeConfirm.text',
        title: 'drawerTabChangeConfirm.title',
        type: OperationType.warning,
        className: 'sm confirm-light'
      }],
      type: OperationType.conditional
    }, {
      independent: true,
      condition: '_.get({drawerState}, "detached")}',
      conditionOperations: [{
        name: 'updateSelectionConfirmed',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }],
    elseOperations: [{
      name: 'updateSelectionConfirmed',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    name: 'updateSelectionConfirmed',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const confirmationQuoteReviewTabChange: Action = [{
  persistent: ['tabEvent', 'filesFilter'],
  type: OperationType.addPersistentData
}, {
  items: [{
    btnConfig: {
      dock: DockType.bottom,
      fillMode: 'flat',
      pos: Position.end
    },
    btnName: 'common.cancel',
    operations: [{
      persistent: ['tabEvent', 'filesFilter'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnConfig: {
      dock: DockType.bottom,
      pos: Position.end,
      themeColor: 'error'
    },
    btnName: 'common.exit',
    close: false,
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }, {
      data: {
        openNotes: false
      },
      moduleName: 'DrawerContent',
      name: 'changeTab',
      args: ['tabEvent', 'filesFilter', 'openNotes']
    }, {
      persistent: ['tabEvent', 'filesFilter'],
      type: OperationType.removePersistentData
    }]
  }],
  text: 'drawerTabChangeConfirm.text',
  title: 'drawerTabChangeConfirm.title',
  className: 'sm confirm-light',
  type: OperationType.warning
}];

export const checkForDrawerChangesBeforeRedirect: Action = [{
  moduleName: 'SubmissionsList',
  name: 'isDrawerOpen',
  type: OperationType.addOperationData
}, {
  condition: '{isDrawerOpen}',
  conditionOperations: [{
    name: 'handleDrawerState',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'handleQuoteChangesCheck',
    type: OperationType.action
  }, {
    moduleName: 'PopupWindow',
    name: 'close'
  }],
  type: OperationType.conditional
}];

export const checkForPreferencesBeforeRedirect: Action = [{
  moduleName: 'Preferences',
  name: 'hasUnsavedChanges',
  args: ['preferencesData'],
  type: OperationType.addOperationData
}, {
  moduleName: 'EmailPreference',
  name: 'hasUnsavedChanges',
  mappingName: 'unsavedNotificationsExists',
  type: OperationType.addOperationData
}, {
  condition: '{hasUnsavedChanges} || {unsavedNotificationsExists}',
  conditionOperations: [{
    name: 'handleSavePreferences',
    type: OperationType.action
  }],
  elseOperations: [{
    type: OperationType.action,
    name: 'reloadPathPD'
  }, {
    moduleName: 'PopupWindow',
    name: 'close'
  }],
  type: OperationType.conditional
}]

export const handleQuoteChangesCheck: Action = [{
  condition: '{path}',
  conditionOperations: [{
    type: OperationType.action,
    name: 'reloadPathPD'
  }],
  elseOperations: [{
    condition: '{leaveAction}',
    switchToAqua: [{
      name: 'switchToAqua',
      moduleName: 'Viewport'
    }],
    tableau: [{
      name: 'openTableauURL',
      moduleName: 'App'
    }],
    safConnect: [{
      name: 'openSafApp',
      moduleName: 'App',
      args: ['leaveAction']
    }],
    safTerminology: [{
      name: 'openSafApp',
      moduleName: 'App',
      args: ['leaveAction']
    }],
    safTM: [{
      name: 'openSafApp',
      moduleName: 'App',
      args: ['leaveAction']
    }],
    type: OperationType.switch
  }],
  type: OperationType.conditional
}]

export const handleDrawerState: Action = [{
  condition: '!_.get({drawerState}, "detached")',
  conditionOperations: [{
    mappingName: 'changeAllowed',
    moduleName: 'DrawerContent',
    name: 'isAllowedTabChange',
    type: OperationType.addOperationData
  }, {
    condition: '{changeAllowed}',
    conditionOperations: [{
      name: 'handleQuoteChangesCheck',
      type: OperationType.action
    }],
    elseOperations: [{
      type: OperationType.addPersistentData,
      persistent: ['path', 'leaveAction']
    }, {
      type: OperationType.warning,
      className: 'sm confirm-light',
      text: 'drawerTabChangeConfirm.text',
      title: 'drawerTabChangeConfirm.title',
      items: [{
        btnName: 'common.cancel',
        btnConfig: {
          fillMode: 'flat',
          pos: Position.end
        },
        operations: [{
          type: OperationType.removePersistentData,
          persistent: ['path', 'leaveAction']
        }]
      }, {
        btnName: 'ESCAPE',
        operations: [{
          type: OperationType.removePersistentData,
          persistent: ['path', 'leaveAction']
        }]
      }, {
        btnName: 'common.exit',
        btnConfig: {
          pos: Position.end,
          themeColor: 'error'
        },
        operations: [{
          name: 'handleQuoteChangesCheck',
          type: OperationType.action
        }, {
          type: OperationType.removePersistentData,
          persistent: ['path', 'leaveAction']
        }]
      }]
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    type: OperationType.action,
    name: 'reloadPathPD'
  }, {
    moduleName: 'PopupWindow',
    name: 'close'
  }],
  type: OperationType.conditional
}];

export const handleQuoteChangesCheckOnCloseDrawer: Action = [{
  condition: '!_.get({drawerState}, "detached")',
  conditionOperations: [{
    mappingName: 'changeAllowed',
    moduleName: 'DrawerContent',
    name: 'isAllowedTabChange',
    type: OperationType.addOperationData
  }, {
    condition: '{changeAllowed}',
    conditionOperations: [{
      name: 'closeDrawer',
      type: OperationType.action
    }],
    elseOperations: [{
      type: OperationType.warning,
      className: 'sm confirm-light',
      text: 'drawerTabChangeConfirm.text',
      title: 'drawerTabChangeConfirm.title',
      items: [{
        btnName: 'common.cancel',
        btnConfig: {
          fillMode: 'flat',
          pos: Position.end
        }
      }, {
        btnName: 'common.exit',
        btnConfig: {
          pos: Position.end,
          themeColor: 'error'
        },
        operations: [{
          name: 'closeDrawer',
          type: OperationType.action
        }]
      }]
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const handleSavePreferences: Action = [{
  type: OperationType.warning,
  warningType: WarningType.info,
  className: 'sm confirm-light',
  closable: true,
  text: 'changePreferenceRoutePrompt.text',
  title: 'changePreferenceRoutePrompt.title',
  items: [{
    btnName: 'changePreferenceRoutePrompt.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['path']
    }]
  }, {
    btnName: 'ESCAPE',
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['path']
    }]
  }, {
    btnName: 'changePreferenceRoutePrompt.exit',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    },
    operations: [{
      type: OperationType.action,
      name: 'reloadPathPD'
    }, {
      type: OperationType.removePersistentData,
      persistent: ['path']
    }]
  }, {
    btnName: 'changePreferenceRoutePrompt.save',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    },
    operations: [{
      moduleName: 'Preferences',
      name: 'getDataForSave',
      mappingName: 'preferenceData',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          bind: {
            languageChanged: '{preferenceData.languageChanged}',
            themeChanged: '{preferenceData.themeChanged}',
            preferencesFormData: '{preferenceData.preferencesFormData}',
            selectedLanguage: '{preferenceData.selectedLanguage}',
            previousPath: '{preferenceData.previousPath}',
            themeCookieName: '{preferenceData.themeCookieName}',
            localeCookieName: '{preferenceData.localeCookieName}',
            theme: '{preferenceData.theme}'
          }
        }
      },
      type: OperationType.action,
      name: 'saveAndUpdatePreference'
    }, {
      type: OperationType.action,
      name: 'reloadPathPD'
    }, {
      type: OperationType.removePersistentData,
      persistent: ['path']
    }]
  }]
}]

export const updateDrawerState: Action = [{
  evaluate: true,
  moduleName: '{currentModuleName}',
  name: 'getDrawerState',
  mappingName: 'drawerOpen',
  type: OperationType.addOperationData
}, {
  moduleName: 'MainGrid',
  name: 'updateDrawerState',
  args: ['drawerOpen']
}];

export const checkboxSelectionClear: Action = [{
  moduleName: 'MainGrid',
  name: 'checkboxSelectionClear'
}];
